import { React, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AxiosApi from "../Helper/axios.api";
import { toast } from "react-toastify";
import PageTitle from "../Components/PageTitle";
import { validateAll } from "indicative/validator";
import { Input, FormFeedback } from "reactstrap";
import { updateUserDetails } from "../Action/Auth.action";
import { Link } from "react-router-dom";

export default function Profile() {
  const dispatch = useDispatch();
  const auth = useSelector((user) => user.auth);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    name: "",
    email: "",
    password: "",
    billingAccount: "",
    billedAccounts: [],
    errors: {},
  });

  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    (async () => {
      await getUser(auth.userDeatils.user_id);
    })();
  }, []);

  const { name, email, password, errors, billingAccount, billedAccounts } = state;

  const onChangeValue = (e) => {
    let value = e.target.value;

    setState({
      ...state,
      [e.target.name]: value,
    });
  };

  const submitUserProfile = (e) => {
    e.preventDefault();
    const rules = {
      name: "required|string",
      email: "required|email",
      password: "string|min:6",
    };
    const message = {
      "name.required": "Name is Required.",
      "email.string": "Email must be string.",
      "email.required": "Email is Required.",
      "email.email": "Please enter valid email.",
      "password.string": "Password must be String.",
      "password.min": "Password must be more then 6 character.",
    };

    validateAll(state, rules, message)
      .then(async () => {
        setState({
          ...state,
          errors: {},
        });
        setLoading(true);
        let data = {};
        data.user_id = auth.userDeatils.user_id;
        data.name = name;
        if (password && password !== "") {
          data.password = password;
        }

        AxiosApi.withToken(auth.accessToken, "user/edit", "post", data)
          .then((res) => {
            if (res.status) {
              dispatch(updateUserDetails(data));
              toast.success(res.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
              setIsUpdate(!isUpdate);
            } else {
              toast.error(res.message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
            setLoading(false);
          })
          .catch((errors_res) => {
            setLoading(false);
          });
      })
      .catch((errors) => {
        setLoading(false);
        const formattedErrors = {};
        errors.forEach(
          (error) => (formattedErrors[error.field] = error.message)
        );
        setState({
          ...state,
          errors: formattedErrors,
        });
      });
  };

  const getUser = async (id) => {
    let data = {};
    await AxiosApi.withToken(auth.accessToken, "user/" + id, "get", data)
      .then(async (res) => {
        if (res.status) {
          setState({
            ...state,
            name: res.data.name,
            email: res.data.email,
            billingAccount: res.data.billing_account,
            billedAccounts: res.data.billed_accounts,
          });
        } else {
          toast.error(res.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        setLoading(false);
      })
      .catch((errors_res) => {
        setLoading(false);
      });
  };

  return (
    <>
      <PageTitle title="DeepTherapy | Profile" />
      <div className="card w-100">
        <div id={loading ? "pageLoader" : ""} />

        <div className="card-header bg-white d-flex align-items-center justify-content-between flex-wrap">
          <div className="card-header-left">
            <div className="card-header-top d-flex align-items-center flex-wrap mb-2">
              <div className="card-title">My Profile</div>
            </div>
          </div>
        </div>

        <div className="card-body">
          <form className="profile-form">
            <div className="profile-form-block">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="mb-2 d-flex align-items-center" style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#495057'
                    }}>
                      <i className="fa fa-user me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                      Name
                    </label>
                    <Input
                      type="text"
                      className="form-control mb-2"
                      invalid={errors.name ? true : false}
                      placeholder="Enter your name"
                      id="name"
                      name="name"
                      value={name}
                      onChange={(e) => onChangeValue(e)}
                      style={{
                        borderRadius: '4px',
                        border: errors.name ? '2px solid #dc3545' : '1px solid #ced4da',
                        backgroundColor: '#ffffff',
                        padding: '8px 12px',
                        fontSize: '14px',
                        fontWeight: '400',
                        transition: 'all 0.2s ease-in-out',
                        boxShadow: errors.name ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1)'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = errors.name ? '#dc3545' : '#007bff';
                        e.target.style.boxShadow = errors.name ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1), 0 0 0 0.1rem rgba(0, 123, 255, 0.25)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = errors.name ? '#dc3545' : '#ced4da';
                        e.target.style.boxShadow = errors.name ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1)';
                      }}
                    />
                    <FormFeedback>{errors.name}</FormFeedback>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label className="mb-2 d-flex align-items-center" style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#495057'
                    }}>
                      <i className="fa fa-envelope me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                      Email
                    </label>
                    <Input
                      type="email"
                      className="form-control mb-2 disabled-email"
                      invalid={errors.email ? true : false}
                      placeholder=""
                      id="email"
                      name="email"
                      value={email}
                      disabled="disabled"
                    />
                    <FormFeedback>{errors.email}</FormFeedback>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="mb-2 d-flex align-items-center" style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#495057'
                    }}>
                      <i className="fa fa-lock me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                      Password
                    </label>
                    <Input
                      type="password"
                      className="form-control mb-2"
                      invalid={errors.password ? true : false}
                      placeholder="Enter new password (optional)"
                      id="password"
                      name="password"
                      onChange={(e) => onChangeValue(e)}
                      style={{
                        borderRadius: '4px',
                        border: errors.password ? '2px solid #dc3545' : '1px solid #ced4da',
                        backgroundColor: '#ffffff',
                        padding: '8px 12px',
                        fontSize: '14px',
                        fontWeight: '400',
                        transition: 'all 0.2s ease-in-out',
                        boxShadow: errors.password ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1)'
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = errors.password ? '#dc3545' : '#007bff';
                        e.target.style.boxShadow = errors.password ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1), 0 0 0 0.1rem rgba(0, 123, 255, 0.25)';
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = errors.password ? '#dc3545' : '#ced4da';
                        e.target.style.boxShadow = errors.password ? '0 0 0 0.1rem rgba(220, 53, 69, 0.2)' : 'inset 0 1px 2px rgba(0, 0, 0, 0.1)';
                      }}
                    />
                    <FormFeedback>{errors.password}</FormFeedback>
                  </div>
                </div>

              </div>
            </div>
            <button
              type="button"
              className="btn btn-primary mt-md-5 mt-3"
              onClick={(e) => submitUserProfile(e)}
            >
              Submit
            </button>
          </form>

        </div>
      </div>

      <div className="card w-100 my-4">
        <div className="card-header bg-white d-flex align-items-center justify-content-between flex-wrap">
          <div className="card-header-left">
            <div className="card-header-top d-flex align-items-center flex-wrap mb-2">
              <div className="card-title">Billing Account</div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="profile-form">
            <div className="profile-form-block">

              <div className="row">

                <div className="col-md-12">
                  <label className="mb-2 d-flex align-items-center" style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#495057'
                  }}>
                    <i className="fa fa-question me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                    What is a billing account?
                  </label>
                  <div className="form-control mb-2">
                    A billing account allows multiple users within the same organization to share a single account for purchasing credits, while maintaining separate logins. This ensures that all user data remains private, while funds can be managed centrally from the billing account.
                    <br />
                    If you designate another account as your billing account, any credits you use will be deducted from that account, and any credits you purchase will be added to it.
                    <br />
                    To manage your billing account, please contact us at <Link to="mailto:info@deeptherapy.ai">info@deeptherapy.ai</Link>.
                  </div>
                </div>
              </div>

              <div className="row">

                <div className="col-md-6">
                  <div className="form-group">
                    <label className="mb-2 d-flex align-items-center" style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#495057'
                    }}>
                      <i className="fa fa-user me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                      Your billing account
                    </label>
                    <Input
                      type="email"
                      className="form-control mb-2 disabled-email"
                      value={billingAccount}
                      disabled="disabled"
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label className="mb-2 d-flex align-items-center" style={{
                      fontSize: '14px',
                      fontWeight: '600',
                      color: '#495057'
                    }}>
                      <i className="fa fa-user me-2" style={{color: '#65badbff', fontSize: '12px'}}></i>
                      Accounts billing you
                    </label>
                    {billedAccounts.length > 0 ? billedAccounts.map((billedAccount) => (
                      <Input
                        key={billedAccount}
                        type="email"
                        className="form-control mb-2 disabled-email"
                        value={billedAccount}
                        disabled="disabled"
                      />
                    )) : <>No accounts are billing you.</>}
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
